import { render, staticRenderFns } from "./headFeeDataTable.vue?vue&type=template&id=23058f9f&scoped=true&lang=true"
import script from "./headFeeDataTable.vue?vue&type=script&lang=js"
export * from "./headFeeDataTable.vue?vue&type=script&lang=js"
import style0 from "./headFeeDataTable.vue?vue&type=style&index=0&id=23058f9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23058f9f",
  null
  
)

export default component.exports